export default [
  // Protected route for logged-in educators
  {
    path: '',
    name: 'insights-private',
    meta: {
      educatorsOnly: true,
      renderNav: true,
      title: 'Insights',
    },
    component: () => import('@/views/educatorHub/dashboards/insights/Insights.vue'),
  },
  // Public route with orgContactId parameter
  {
    path: ':orgContactId(\\d+)',
    name: 'insights-shared',
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Insights - Shared',
    },
    component: () => import('@/views/educatorHub/dashboards/insights/Insights.vue'),
  },
];